module.exports = __webpack_public_path__ + "static/media/search-employees-filter.4de61e5d.svg";